// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

const initialState = {
  imagesArray: [],
  totalImages: 0,
};

function imagesReviewReducer(state = initialState, action = '') {
  return produce(state, (draft) => {
    switch (action.type) {
      case 'imagesReview/add':
        draft.imagesArray.splice(0, state.totalImages);
        draft.imagesArray.push(action.payload.images);
        // eslint-disable-next-line no-param-reassign
        draft.totalImages = action.payload.totalImages;
        break;
      case 'imagesReview/remove':
        draft.imagesArray.splice(0, state.totalImages);
        // eslint-disable-next-line no-param-reassign
        draft.totalImages = 0;
        break;
      default:
        break;
    }
  });
}

export default imagesReviewReducer;
